import { render } from "./3.ProductDetails.vue?vue&type=template&id=d2ec27fe&scoped=true"
import script from "./3.ProductDetails.vue?vue&type=script&lang=js"
export * from "./3.ProductDetails.vue?vue&type=script&lang=js"

import "./3.ProductDetails.vue?vue&type=style&index=0&id=d2ec27fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2ec27fe"]])

export default __exports__